import React from "react"
import badge from "badges/galactic-master.svg"
import { BadgeImage } from "backpack/badges/styled"

const GalacticMaster = props => <BadgeImage src={badge} {...props} />

export default GalacticMaster
